// src/lib/metroCopy.js
//
// Canonical Metro Bank introduction disclaimer. Metro requires that customers are
// told, wherever the introduction is offered or confirmed, that this is an
// introduction only and the bank is under no obligation to open an account for a
// customer who doesn't meet its requirements.
//
// Used on the formation landing page and at the point of consent. The
// introduction email (server-side, server/services/email.js `referral_introduced`)
// mirrors this exact string — keep the two in step.
export const METRO_INTRO_DISCLAIMER =
  'This is an introduction to Metro Bank only. Metro Bank is under no obligation to open an account and will do so only if you meet its eligibility and account-opening requirements.';
